import { apiClient } from '../config';

// Fetch service types from /items/service_type
export const fetchServiceTypes = async () => {
  try {
    console.log(`Fetching service types from /items/service_type`);
    const response = await apiClient.get('/items/service_type');
    console.log('Service types response:', response.data);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching service types:', error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

